import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddCustomGroupForm({ open, onClose, onSubmit }) {
  const [type, setType] = useState("customer"); // default type
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddGroup = async () => {
    try {
      setLoading(true);

      const payload = {
        companyId: process.env.REACT_APP_COMPANY_ID, // dynamic from env
        type,
        name,
        description,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/groups`,
        payload
      );

      if (onSubmit) {
        onSubmit(response.data); // update parent instantly
      }

      // reset form after submit
      setType("customer");
      setName("");
      setDescription("");

      console.log("✅ Group created:", response.data);
      toast.success("✅ Group created successfully!");
    } catch (error) {
      console.error(
        "❌ Error creating group:",
        error.response?.data || error.message
      );
      toast.error(error.response?.data?.message || "❌ Failed to create group");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Customer Group</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            select
            label="Type *"
            value="customer" // preselected value
            fullWidth
            disabled // disables user interaction
          >
            <MenuItem value="customer">Customer</MenuItem>
          </TextField>

          <TextField
           sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            label="Name *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
          />

          <TextField
           sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 0, // ✅ remove rounding
                      },
                    }}

            label="Description *"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={onClose}
          color="error"
        >
          Cancel
        </Button>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={handleAddGroup}
          variant="contained"
          color="primary"
          disabled={loading || !name || !description}
        >
          {loading ? "Adding..." : "Add Group"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
